import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { AuthShell } from '@/components/portal/AuthShell'
import { LanguageSelect } from '@/components/portal/LanguageSelect'

export function WelcomePage() {
  const { t } = useTranslation()

  return (
    <AuthShell>
      <h1 className="prod-auth__title prod-welcome__title">{t('welcome.title')}</h1>
      <p className="prod-welcome__lead">{t('welcome.valueLine')}</p>

      <div className="prod-welcome__paths">
        <section className="prod-welcome__path" aria-labelledby="welcome-sign-in">
          <h2 id="welcome-sign-in" className="prod-welcome__path-title">
            {t('welcome.signInTitle')}
          </h2>
          <p className="prod-welcome__path-hint">{t('welcome.signInHint')}</p>
          <Link to="/login" className="prod-btn prod-btn--gold prod-btn--gold-full">
            {t('auth.signIn')}
          </Link>
        </section>
        <section className="prod-welcome__path" aria-labelledby="welcome-sign-up">
          <h2 id="welcome-sign-up" className="prod-welcome__path-title">
            {t('welcome.signUpTitle')}
          </h2>
          <p className="prod-welcome__path-hint">{t('welcome.signUpHint')}</p>
          <Link to="/sign-up" className="prod-btn prod-btn--outline prod-btn--gold-full">
            {t('auth.signUp')}
          </Link>
        </section>
      </div>

      <div className="prod-welcome__lang">
        <p className="prod-auth__subtitle prod-auth__subtitle--flush">{t('welcome.chooseLanguage')}</p>
        <div className="prod-lang-row">
          <LanguageSelect variant="panel" className="prod-lang-select__trigger--welcome" />
        </div>
      </div>
    </AuthShell>
  )
}
